import request from '@/utils/request'
// 注册账号
export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}
// 用户登录
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}
// 用户登录
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post',
  })
}
// 卡密兑换
export function cardExchange(data) {
  return request({
    url: '/vip/redeem',
    method: 'post',
    data
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/auth/changePassword',
    method: 'post',
    data
  })
}
//获取资源列表
export function getList(params) {
  return request({
    url: '/resource',
    method: 'get',
    params
  })
}
//添加资源
export function addGame(data) {
  return request({
    url: '/resource',
    method: 'post',
    data
  })
}

//获取资源详情信息
export function getInfo(id) {
  return request({
    url: `/resource/${id}`,
    method: 'get'
  })
}

export function getInfoAdmin(id) {
  return request({
    url: `/resource/detailAdmin/${id}`,
    method: 'get'
  })
}

//获取资源下载地址
export function getInfoDownLoad(id) {
  return request({
    url: `/resource/${id}/download`,
    method: 'post'
  })
}
//修改资源
export function updateGame(data) {
  return request({
    url: `/resource/${data.id}`,
    method: 'put',
    data
  })
}

//删除资源
export function deleteGame(id) {
  return request({
    url: `/resource/${id}`,
    method: 'delete'
  })
}

//获取用户列表
export function getUserList(params) {
  return request({
    url: '/users',
    method: 'get',
    params
  })
}

//新增用户
export function addUser(data) {
  return request({
    url: `/users`,
    method: 'post',
    data
  })
}

export function getUserInfo(id) {
  return request({
    url: `/users/${id}`,
    method: 'get'
  })
}
//更新用户
export function updateUser(data) {
  return request({
    url: `/users/${data.id}`,
    method: 'put',
    data
  })
}
//删除用户
export function deleteUser(id) {
  return request({
    url: `/users/${id}`,
    method: 'delete'
  })
}

// 封禁/解封用户
export function setUserBanStatus(id, data) {
  return request({
    url: `/users/${id}/ban`,
    method: 'post',
    data
  })
}

// 每日风控统计
export function getDailyRiskStats(params) {
  return request({
    url: '/users/risk/daily-stats',
    method: 'get',
    params
  })
}

// 手动标记每日异常用户
export function markDailyRiskUser(id, data) {
  return request({
    url: `/users/${id}/risk-mark`,
    method: 'post',
    data
  })
}

// 获取用户当日风控详情
export function getUserDailyRiskDetail(id, params) {
  return request({
    url: `/users/risk/${id}/detail`,
    method: 'get',
    params
  })
}


//获取卡密列表
export function getCardList(params) {
  return request({
    url: '/vip/cards',
    method: 'get',
    params
  })
}

//新增卡密
export function addCard(data) {
  return request({
    url: `/vip/cards`,
    method: 'post',
    data
  })
}

//删除卡密
export function deleteCard(id) {
  return request({
    url: `/vip/cards/${id}`,
    method: 'delete'
  })
}


//批量删除卡密

export function batchDeleteCard(data) {
  return request({
    url: `/vip/cards/batchDelete`,
    method: 'post',
    data
  })
}

//数据导入
export function importResource(data) {
  return request({
    url: `/resource/import`,
    method: 'post',
    data
  })
}

//开始爬虫

export function startCrawler(data) {
  return request({
    url: `/resource/startCrawler`,
    method: 'post',
    data
  })
}


//获取下载日志

export function historyDownload(data) {
  return request({
    url: `/resource/historyDownload`,
    method: 'post',
    data
  })
}

//新增魔趣账号
export function addMoquAccount(data) {
  return request({
    url: `/moqu`,
    method: 'post',
    data
  })
}


export function listMoquAccount(params) {
  return request({
    url: `/moqu`,
    method: 'get',
    params
  })
}


export function moquAccountInfo(id) {
  return request({
    url: `/moqu/${id}`,
    method: 'get'
  })
}
//更新用户
export function updateMoquAccount(data) {
  return request({
    url: `/moqu/${data.id}`,
    method: 'put',
    data
  })
}
//删除用户
export function deleteMoquAccount(id) {
  return request({
    url: `/moqu/${id}`,
    method: 'delete'
  })
}


//一键更新token
export function refreshAllTokens() {
  return request({
    url: `/moqu/refreshAllTokens`,
    method: 'post'
  })
}








export function getMqList(params) {
  return request({
    url: '/moquResource',
    method: 'get',
    params
  })
}
//添加资源
export function addMqGame(data) {
  return request({
    url: '/moquResource',
    method: 'post',
    data
  })
}

//获取资源详情信息
export function getMqInfo(id) {
  return request({
    url: `/moquResource/${id}`,
    method: 'get'
  })
}

export function getMqInfoAdmin(id) {
  return request({
    url: `/moquResource/detailAdmin/${id}`,
    method: 'get'
  })
}

//获取资源下载地址（旧版，保留兼容）
export function getMqInfoDownLoad(id) {
  return request({
    url: `/moquResource/${id}/download`,
    method: 'post'
  })
}

// ========== 新版两步下载流程 ==========
// 第一步：获取下载选项（不返回真实URL，不扣费）
export function getDownloadOptions(id) {
  return request({
    url: `/moquResource/${id}/download-options`,
    method: 'get'
  })
}

// 第二步：获取真实下载链接（检查24h记录，扣费，返回真实URL）
export function getActualDownloadLink(id, data) {
  return request({
    url: `/moquResource/${id}/actual-download`,
    method: 'post',
    data // { type: 'cloud' | 'tianyi', index: 0 }
  })
}

// 申请天翼云直连
export function requestTianyiDirect(id) {
  return request({
    url: `/moquResource/${id}/request-tianyi-direct`,
    method: 'post'
  })
}

//修改资源
export function updateMqGame(data) {
  return request({
    url: `/moquResource/${data.id}`,
    method: 'put',
    data
  })
}

//删除资源
export function deleteMqGame(id) {
  return request({
    url: `/moquResource/${id}`,
    method: 'delete'
  })
}


export function importMqResource(data) {
  return request({
    url: `/moquResource/import`,
    method: 'post',
    data
  })
}

//开始爬虫

export function startMqCrawler(data) {
  return request({
    url: `/moquResource/startCrawler`,
    method: 'post',
    data
  })
}


export function getSingleGame(id) {
  return request({
    url: `/moquResource/getSingleGame/${id}`,
    method: 'post'
  })
}



export function mqHistoryDownload(data) {
  return request({
    url: `/moquResource/historyDownload`,
    method: 'post',
    data
  })
}

//获取直连下载列表
export function getMqDirectDownloadList(id, params) {
  return request({
    url: `/moquResource/${id}/downlinks`,
    method: 'get',
    params
  })
}

// 获取真实下载地址
export function getRealDownloadUrl(data) {
  return request({
    url: '/moquResource/getRealDownloadUrl',
    method: 'post',
    data
  })
}

// 创建下载令牌（安全的两步下载）
export function createDownloadToken(data) {
  return request({
    url: '/moquResource/createDownloadToken',
    method: 'post',
    data
  })
}

// 获取代理下载日志列表
export function getProxyDownloadLogs(params) {
  return request({
    url: '/moquResource/proxyDownloadLogs',
    method: 'get',
    params
  })
}

// 获取123网盘真实直连下载日志列表
export function getUrlDownloadLogs(params) {
  return request({
    url: '/moquResource/urlDownloadLogs',
    method: 'get',
    params
  })
}

// 代理下载文件（流式下载）
export function proxyDownload(data) {
  return request({
    url: '/moquResource/proxyDownload',
    method: 'post',
    data,
    responseType: 'blob'
  })
}




//开通代理接口功能


//创建代理人员
export function createAgent(data) {
  return request({
    url: `/agent/create`,
    method: 'post',
    data
  })
}

export function getMySettings() {
  return request({
    url: `/agent/getSettings`,
    method: 'get',
  })
}

export function setMySettings(data) {
  return request({
    url: `/agent/settings`,
    method: 'post',
    data
  })
}
export function getSettings(data) {
  return request({
    url: `/agent/getBuyLinks`,
    method: 'post',
    data
  })
}



export function importUserNameData(data) {
  return request({
    url: '/moqu/importUserNameData',
    method: 'post',
    data
  })
}

// 123网盘Token管理相关API

// 获取Token列表
export function getPan123Tokens(params) {
  return request({
    url: '/pan123/tokens',
    method: 'get',
    params
  })
}

// 创建Token
export function createPan123Token(data) {
  return request({
    url: '/pan123/tokens',
    method: 'post',
    data
  })
}

// 获取Token详情
export function getPan123TokenDetail(id) {
  return request({
    url: `/pan123/tokens/${id}`,
    method: 'get'
  })
}

// 更新Token
export function updatePan123Token(id, data) {
  return request({
    url: `/pan123/tokens/${id}`,
    method: 'put',
    data
  })
}

// 删除Token
export function deletePan123Token(id) {
  return request({
    url: `/pan123/tokens/${id}`,
    method: 'delete'
  })
}

// 批量删除Token
export function batchDeletePan123Tokens(data) {
  return request({
    url: '/pan123/tokens/batchDelete',
    method: 'post',
    data
  })
}

// 使用Token（增加使用次数）
export function usePan123Token(id, data) {
  return request({
    url: `/pan123/tokens/${id}/use`,
    method: 'post',
    data
  })
}

// 重置Token使用次数
export function resetPan123Token(id) {
  return request({
    url: `/pan123/tokens/${id}/reset`,
    method: 'post'
  })
}

// 获取可用Token
export function getAvailablePan123Token() {
  return request({
    url: `/pan123/available`,
    method: 'get'
  })
}

// 获取系统配置
export function getSystemConfig() {
  return request({
    url: `/agent/systemConfig`,
    method: 'get'
  })
}

// 修改系统配置
export function updateSystemConfig(data) {
  return request({
    url: `/agent/systemConfig`,
    method: 'post',
    data
  })
}

// 上传系统文件
export function uploadSystemFile(formData) {
  return request({
    url: `/upload/system-file`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取公共系统配置
export function getPublicSystemConfig(data) {
  return request({
    url: `/agent/getPublicSystemConfig`,
    method: 'post',
    data
  })
}

// 123网盘缓存管理相关接口
// 获取缓存列表
export function getPan123CacheList(params) {
  return request({
    url: '/pan123/cache',
    method: 'get',
    params
  })
}

// 添加缓存任务
export function createPan123Cache(data) {
  return request({
    url: '/pan123/cache',
    method: 'post',
    data
  })
}

// 获取缓存详情
export function getPan123CacheDetail(id) {
  return request({
    url: `/pan123/cache/${id}`,
    method: 'get'
  })
}

// 更新缓存
export function updatePan123Cache(id, data) {
  return request({
    url: `/pan123/cache/${id}`,
    method: 'put',
    data
  })
}

// 删除缓存
export function deletePan123Cache(id) {
  return request({
    url: `/pan123/cache/${id}`,
    method: 'delete'
  })
}

// 批量删除缓存
export function batchDeletePan123Cache(data) {
  return request({
    url: '/pan123/cache/batch-delete',
    method: 'post',
    data
  })
}

// 获取缓存统计信息
export function getPan123CacheStats() {
  return request({
    url: '/pan123/cache/stats',
    method: 'get'
  })
}

// 刷新缓存
export function refreshPan123Cache(id) {
  return request({
    url: `/pan123/cache/${id}/refresh`,
    method: 'post'
  })
}

// 清理过期缓存
export function cleanExpiredPan123Cache() {
  return request({
    url: '/pan123/cache/clean-expired',
    method: 'post'
  })
}


// ==================== 天翼云集成相关接口 ====================

// 天翼云健康检查
export function tianyiHealthCheck() {
  return request({
    url: '/tianyi/health',
    method: 'get'
  })
}

// 获取天翼云账号列表（管理员）
export function getTianyiAccounts() {
  return request({
    url: '/tianyi/accounts',
    method: 'get'
  })
}

// 触发天翼云账号登录（管理员）
export function loginTianyiAccount(id) {
  return request({
    url: `/tianyi/accounts/${id}/login`,
    method: 'post'
  })
}

// 检查天翼云账号状态（管理员）
export function checkTianyiAccountStatus(id) {
  return request({
    url: `/tianyi/accounts/${id}/status`,
    method: 'get'
  })
}

// 列出天翼云文件
export function listTianyiFiles(accountId, params) {
  return request({
    url: `/tianyi/files/${accountId}`,
    method: 'get',
    params
  })
}

// 获取天翼云文件直链
export function getTianyiDownloadLink(accountId, fileId, params) {
  return request({
    url: `/tianyi/files/${accountId}/link/${fileId}`,
    method: 'get',
    params
  })
}

// 绑定天翼云文件到资源（管理员）
export function bindTianyiFile(resourceId, data) {
  return request({
    url: `/tianyi/bind/${resourceId}`,
    method: 'post',
    data
  })
}

// 获取待上传资源列表（管理员）
export function getPendingResources(params) {
  return request({
    url: '/tianyi/pending',
    method: 'get',
    params
  })
}

// 获取已绑定天翼云的资源列表（管理员）
export function getBoundResources(params) {
  return request({
    url: '/tianyi/bound',
    method: 'get',
    params
  })
}

// 搜索所有资源（用于手动绑定）
export function searchAllResources(params) {
  return request({
    url: '/tianyi/search',
    method: 'get',
    params
  })
}

// 统一下载入口（根据 storage_type 自动路由）
export function getUnifiedDownloadLink(id, params) {
  return request({
    url: `/moquResource/${id}/download-link`,
    method: 'get',
    params
  })
}

// 获取资源存储信息
export function getResourceStorageInfo(id) {
  return request({
    url: `/moquResource/${id}/storage-info`,
    method: 'get'
  })
}

// 自动上传到天翼云
export function autoUploadToTianyi(resourceId, data) {
  return request({
    url: `/tianyi/auto-upload/${resourceId}`,
    method: 'post',
    data
  })
}

// 获取远程下载任务状态
export function getTianyiTaskStatus(taskId) {
  return request({
    url: `/tianyi/task/${taskId}`,
    method: 'get'
  })
}

// 获取远程下载任务列表
export function getTianyiTaskList(params) {
  return request({
    url: '/tianyi/tasks',
    method: 'get',
    params
  })
}

// 重置资源上传状态
export function resetResourceUploadStatus(resourceId) {
  return request({
    url: `/tianyi/reset-status/${resourceId}`,
    method: 'post'
  })
}

// 从待上传列表移除（不删除游戏）
export function removeFromPendingList(resourceId) {
  return request({
    url: `/tianyi/remove-pending/${resourceId}`,
    method: 'post'
  })
}

// 获取资源上传任务进度
export function getResourceTaskProgress(resourceId) {
  return request({
    url: `/tianyi/progress/${resourceId}`,
    method: 'get'
  })
}

// 获取自动上传服务状态
export function getAutoUploadStatus() {
  return request({
    url: '/tianyi/auto-upload/status',
    method: 'get'
  })
}

// 手动触发自动上传
export function triggerAutoUpload() {
  return request({
    url: '/tianyi/auto-upload/trigger',
    method: 'post'
  })
}

// 获取自动上传配置
export function getAutoUploadConfig() {
  return request({
    url: '/tianyi/auto-upload/config',
    method: 'get'
  })
}

// 获取所有自动上传配置
export function getAllAutoUploadConfigs() {
  return request({
    url: '/tianyi/auto-upload/configs',
    method: 'get'
  })
}

// 保存自动上传配置
export function saveAutoUploadConfig(data) {
  return request({
    url: '/tianyi/auto-upload/config',
    method: 'post',
    data
  })
}

// 删除自动上传配置
export function deleteAutoUploadConfig(id) {
  return request({
    url: `/tianyi/auto-upload/config/${id}`,
    method: 'delete'
  })
}

// 设置默认自动上传配置
export function setDefaultAutoUploadConfig(id) {
  return request({
    url: `/tianyi/auto-upload/config/${id}/default`,
    method: 'post'
  })
}

// ========== 天翼直连申请管理 ==========
// 获取申请列表
export function getTianyiDirectRequests(params) {
  return request({
    url: '/moquResource/admin/tianyi-requests',
    method: 'get',
    params
  })
}

// 删除申请
export function deleteTianyiDirectRequest(id) {
  return request({
    url: `/moquResource/admin/tianyi-requests/${id}`,
    method: 'delete'
  })
}

// 重试申请
export function retryTianyiDirectRequest(id) {
  return request({
    url: `/moquResource/admin/tianyi-requests/${id}/retry`,
    method: 'post'
  })
}

// 批量删除申请
export function batchDeleteTianyiDirectRequests(ids) {
  return request({
    url: '/moquResource/admin/tianyi-requests/batch-delete',
    method: 'post',
    data: { ids }
  })
}

// 获取热门游戏排行榜
export function getHotRanking(data) {
  return request({
    url: '/moquResource/hotRanking',
    method: 'post',
    data
  })
}

// ==================== 魔趣直连额度配置 ====================

// 获取管理员配置
export function getMoquDirectLimitConfig() {
  return request({
    url: '/moquDirectLimit/config',
    method: 'get'
  })
}

// 更新管理员配置
export function updateMoquDirectLimitConfig(data) {
  return request({
    url: '/moquDirectLimit/config',
    method: 'post',
    data
  })
}

// 获取当前用户每日额度状态
export function getMyMoquDirectLimitStatus() {
  return request({
    url: '/moquDirectLimit/my-status',
    method: 'get'
  })
}

// 获取用户专属额度覆盖列表（管理员）
export function getMoquDirectUserOverrides(params) {
  return request({
    url: '/moquDirectLimit/user-overrides',
    method: 'get',
    params
  })
}

// 获取指定用户专属额度覆盖（管理员）
export function getMoquDirectUserOverride(userId) {
  return request({
    url: `/moquDirectLimit/user-overrides/${userId}`,
    method: 'get'
  })
}

// 设置指定用户专属额度覆盖（管理员）
export function upsertMoquDirectUserOverride(userId, data) {
  return request({
    url: `/moquDirectLimit/user-overrides/${userId}`,
    method: 'post',
    data
  })
}

// 按用户名设置用户专属额度覆盖（管理员）
export function upsertMoquDirectUserOverrideByName(data) {
  return request({
    url: '/moquDirectLimit/user-overrides/by-username',
    method: 'post',
    data
  })
}

// 删除指定用户专属额度覆盖（管理员）
export function deleteMoquDirectUserOverride(userId) {
  return request({
    url: `/moquDirectLimit/user-overrides/${userId}`,
    method: 'delete'
  })
}
